import { Component, HostBinding, Input, OnChanges, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { CreditCardShared } from '../../../models/interface/creditCard.interface';
import { Actions } from '../../../types/actions.type';
import { MuRadioCreditCardType } from './models/mu-radio-credit-card-type.enum';

@Component({
  selector: 'app-mu-radio-credit-card',
  templateUrl: './mu-radio-credit-card.component.html',
  styleUrls: ['./mu-radio-credit-card.component.sass'],
})
export class MuRadioCreditCardComponent<ActionType> implements OnInit, OnChanges {
  @Input() creditCard: CreditCardShared;
  @Input() controlName: string;
  @Input() formData: UntypedFormGroup;
  @Input() disabled: boolean;
  @Input() skin: boolean;
  @Input() action: ActionType;
  @Input() actionList: Actions<ActionType, any>;
  @Input() hidden: boolean;
  @HostBinding('class') baseClass: string;
  radioCreditCardType = MuRadioCreditCardType;

  constructor(private translateService: TranslateService) {
    /* */
  }

/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
  ngOnInit(): void {
    /* */
  }
/* eslint-enable @angular-eslint/no-empty-lifecycle-method */

  ngOnChanges(): void {
    if (this.hidden) {
      this.baseClass = 'mu-radio-credit-card-hidden';
      return environment.guardClause;
    }
    this.baseClass = '';
  }

  /**
   * emit main action
   */
  actionEvent(): void {
    this.actionList?.emit(this.creditCard?.action, null);
  }

  /**
   * get radio label
   */
  get label(): string {
    const tmpLabel = this.creditCard?.label
      ? this.translateService.instant('form.label.' + this.creditCard?.label)
      : this.translateService.instant('form.label.' + this.creditCard?.franchise);
    return this.creditCard?.last4digits
      ? this.translateService.instant('creditCard.franchiseKey', { franchise: this.creditCard?.franchise })
      : tmpLabel;
  }
}
